import React, { useCallback, useContext, useEffect, useState } from 'react';
import i18next from 'i18next';
import NotesList from '../../../notes/NotesList';
import EAAccordion from '../../../../components/EAAccordion';
import {
  createNoteContextTP,
  deleteNoteContextTP,
  getAllNoteContextTP,
  updateNoteContextTP,
} from '../../../../services/edge/NoteService';
import { Context } from '../../../../states/Store';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from '../../../../services/common/RolesUtils';

const Notes = ({ contexThirdParty }) => {
  const [state, dispatch] = useContext(Context);
  const [notes, setNotes] = useState([]);
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const createNote = async (noteContent) => {
    await createNoteContextTP(
      state.account.id,
      contexThirdParty.compteFoId,
      contexThirdParty.id,
      noteContent,
      dispatch
    );
  };

  const updateNote = useCallback(
    async (noteOId, noteContent) => {
      await updateNoteContextTP(
        state.account.id,
        contexThirdParty.compteFoId,
        contexThirdParty.id,
        noteOId,
        noteContent,
        dispatch
      );
    },
    [contexThirdParty,dispatch,state.account.id]
  );

  const deleteNote = useCallback(
    async (noteOId) => {
      await deleteNoteContextTP(
        state.account.id,
        contexThirdParty.compteFoId,
        contexThirdParty.id,
        noteOId,
        dispatch
      );
    },
    [contexThirdParty, dispatch, state.account.id]
  );

  const fetchNotes = useCallback(() => {
    async function getNotes() {
      try {
        const result = await getAllNoteContextTP(
          state.account.id,
          contexThirdParty.compteFoId,
          contexThirdParty.id,
          dispatch
        );
        setNotes(result.content);
      } catch (error) {
        setNotes(null);
      }
    }

    getNotes();
  }, [contexThirdParty, state.account.id, dispatch]);

  useEffect(() => {
    fetchNotes();
  }, [fetchNotes]);

  return (
    <>
      {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_NOTES) ? (
        <EAAccordion
          title={i18next.t('notes.title')}
          logo="note"
          counter={notes?.length}
          opened={false}
          notificationCounter={0} // TODO change when notifications counter is available
          disabled={
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_CREATE_CONTEXT_NOTES)
          }
        >
          {notes && (
            <NotesList
              notes={notes}
              fetchNotes={fetchNotes}
              createNote={createNote}
              updateNote={updateNote}
              deleteNote={deleteNote}
              type="CONTEXT"
            />
          )}
        </EAAccordion>
      ) : (
        <></>
      )}
    </>
  );
};

export default Notes;
